"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CLEAR_ICON = undefined;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CLEAR_ICON = exports.CLEAR_ICON = _react2.default.createElement(
  "svg",
  { height: "20", width: "20", viewBox: "0 0 24 24" },
  _react2.default.createElement("path", { d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" }),
  _react2.default.createElement("path", { d: "M0 0h24v24H0z", fill: "none" })
);


//////////////////
// WEBPACK FOOTER
// ./~/react-date-picker/lib/DateField/icons.js
// module id = 864
// module chunks = 0